// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Spin/index.less
// module id = 1715
// module chunks = 0